import { take, put, all, select, takeEvery } from 'redux-saga/effects';
import {
  setRoomId,
  GET_ROOMDATA,
} from './actions';


export function* getRoomDataFlow(){
  yield put(setRoomId({selectedId:1}));
}
export function* watchGetRoom() {
  yield takeEvery(GET_ROOMDATA, getRoomDataFlow);
}

export default function* roomRoot() {
  yield all([watchGetRoom()]);
}



// WEBPACK FOOTER //
// ./src/redux/room/sagas.js